import React, { Component } from 'react'
import IntractionActionsList from '../IntractionActionsList'
// import StagesManager from '../StagesManager'
// import TasksList from './TasksList'
import { checkConditionGroup, checkPermission, checkTranslation, isWhite } from '../../utils/useful'

export default class ActionsList extends Component {

    state = {}

    componentDidMount() {

        if (this.props.data && this.props.data.stage) {
            this.init()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data || this.props.currentRecordStage != prevProps.currentRecordStage) {
            this.init()
        }
    }



    init = () => {
        // console.log('*initAC')
        if (this.props.data && this.props.data.stage) {
            // let value = this.props.data["**stage"]?.value?.stage?.id
            let value = this.props.data.stage

            let history = this.props.data.history

            let stages
            if (this.props.data.workflow?.stages) {
                stages = JSON.parse(JSON.stringify(this.props.data.workflow?.stages))
            }
            let nextStages = []
            let lastStages = []
            let currentStage
            let backIsWhite = false

            if (Array.isArray(stages)) {

                stages.forEach(stage => {
                    if (stage.id == value) {
                        currentStage = stage
                        backIsWhite = isWhite(currentStage.color?.background)

                    }
                });

                stages.forEach(stage => {

                    if (currentStage && Array.isArray(currentStage.to) && currentStage.to.includes(stage.id)) {
                        nextStages.push(stage)
                    }

                })

            }
            // console.log('history', history)
            if (Array.isArray(history)) {
                this.findLastStage(history, lastStages, stages, history.length - 1, 0)
                // for (let i = history.length - 1; i >= 0; i--) {
                //     stages.forEach(stage => {
                //         console.log(i)
                //         if (history[i].oldStage == stage.id && stage.type != 'trigger' && history[i].action != 'lastStage') {
                //             console.log('Lstage', stage, i)
                //             lastStages.push(stage)
                //         } else if (history[i].action == 'lastStage' && i > 0) {
                //             console.log('=========', i)
                //             i = i - 1
                //             console.log(history, '-------', i)
                //         }

                //     })
                // }
            }



            this.setState({ allStages: stages, nextStages, lastStages })
        }

    }
    findLastStage = (history, lastStages, stages, index, times) => {
        if (index != 0) {
            // console.log('index check', index, times)
            let found
            let target
            // console.log('vhistory', history)
            if (history[index]) {

                if (history[index].action == 'lastStage') {
                    times = times + 1
                    this.findLastStage(history, lastStages, stages, (index - 1), times)
                    return
                } else {
                    if (times) {
                        let nIndex = index - times
                        // console.log('goes to ', nIndex, times)
                        times = 0
                        this.findLastStage(history, lastStages, stages, nIndex, times)
                    } else {
                        if (Array.isArray(stages)) {
                            stages.map((stage) => {
                                if (history[index].oldStage == stage.id && stage.type != 'trigger') {
                                    found = true
                                    target = stage
                                }

                            })
                        }
                    }
                }
                if (found) {
                    lastStages.push(target)
                }
                this.findLastStage(history, lastStages, stages, (index - 1), times)
            } else {
                return lastStages

            }

        } else {
            // console.log('lastStages', lastStages)
            return lastStages
        }
    }
    render() {

        let actions = this.props.page?.actions ?? (this.props.actions ? Object.values(this.props.actions) : [])

        // console.log(this.props.page)
        // let requiredPermission = `collection.${this.props.page._id}`
        return (
            <div className='w-100' >

                {Array.isArray(actions) && actions.map((item, index) => {
                    // {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                    // checkPermission
                    // console.log('itemitemitemitem',item)
                    let type = item.type ?? item.key
                    let refAction = this.props.actions[type]
                    let canShow = true
                    let nextStage
                    let lastStage
                    if (type == "nextStage") {
                        if (Array.isArray(this.state.nextStages) && this.state.nextStages?.length > 0) {
                            nextStage = this.state.nextStages.length > 1 ? '' : this.state.nextStages[0]
                        } else {
                            canShow = false
                        }
                    }
                    if (type == "lastStage") {
                        if (Array.isArray(this.state.lastStages) && this.state.lastStages?.length > 0) {
                            lastStage = this.state.lastStages[0]
                        } else {
                            canShow = false
                        }
                    }
                    // console.log(refAction)
                    if (refAction?.conditions) {
                        canShow = checkConditionGroup(refAction.conditions, { data: this.props.data })
                    }
                    // let description = type == "nextStage" ? 'Stage name' : null

                    // let permission = type
                    // if (this.props.actions[type] && (checkPermission(this.props.permissions, `${requiredPermission}.addNewRecord`) && this.props.appletAccess)) {
                    // console.log('this.props.actionslsp',this.props.actions)
                    // console.log('actions',actions)
                    // console.log(canShow, type)
                    if (canShow && this.props.actions[type]) {
                        let prop = this.props.actions[type]
                        return (

                            <div className='w-100 br-4' key={item.key ?? item._id} >
                                {/* <IntractionActionsList key={index} stage={0} stageName='main' onClick={() => this.props.actionClicked(prop, this.props.data, this.props.index)} language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: prop.icon }} /> */}

                                <button className="flexcb w-100 hover-gray-no-filter p-2 br-5" onClick={() => this.props.actionClicked(prop, { action: item, data: this.props.data })}>
                                    <div className='d-flex'>
                                        <div className='flexcc'>
                                            <img className='toolbar-icon flexcc' width={16} height={16} style={{ objectFit: 'contain' }} src={prop.icon} alt='' />
                                        </div>
                                        <div>
                                            <div>
                                                <p className="font-size-12 mld-3 main-c3 text-start text-semibold" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(prop.label)}</p>
                                                {/* {(this.props.description || this.props.data.des) && (
                                                <p className="font-size-10 mld-3 main-c7 text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(this.props.description ?? this.props.data.des)}</p>
                                            )} */}
                                            </div>


                                            {(type == "nextStage") && (
                                                <div className='flexc px-1'>
                                                    <div className='br-20 px-2 py-1 mt-1' style={{ background: nextStage?.color?.background, color: '#000', }}>
                                                        <p className="font-size-10  text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(nextStage?.name)}</p>
                                                    </div>
                                                </div>
                                            )}

                                            {(type == "lastStage") && (
                                                <div className='flexc px-1'>
                                                    <div className='br-20 px-2 py-1 mt-1' style={{ background: lastStage?.color?.background ?? 'rgb(241, 234, 255)', color: '#000', }}>
                                                        <p className="font-size-10  text-start" style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{checkTranslation(lastStage?.name)}</p>
                                                    </div>
                                                </div>
                                            )}

                                        </div>

                                    </div>



                                    <div className='font-size-10 main-c8'>
                                        {prop.sub == true && (
                                            <img className='flexcc rtl-button rotate-0' width={18} src={"/assets/icons/imports/arrowRight.svg"} alt='' />
                                        )}
                                    </div>

                                </button>




                            </div>
                            // <button onClick={() => this.actionClicked(prop, this.props.data, this.props.index)} className="w-100 p-0 text-start flexc pt-1 mt-1" style={{}}>
                            //     <div className='px-3 flexcb w-100'>

                            //         <p className="text-small text-semibold" style={{ color: prop.color }}>{checkTranslation(prop.label)}</p>
                            //         <div className='flexcc mrd-2'>
                            //             <img src={prop.icon} width={16} />
                            //         </div>
                            //     </div>
                            // </button>

                        )
                    }
                })}
            </div >
        )
    }
}
